export enum TipoOrigem {
    Site = 1,
    Mobile = 2
}